import script from "./TeacherCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherCard.vue?vue&type=script&setup=true&lang=js"

import "./TeacherCard.vue?vue&type=style&index=0&id=bf1c4eca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf1c4eca"]])

export default __exports__